module.exports = __webpack_public_path__ + "Banner_Medical_repeatable-131dd403b23187b726406294f08bdd0b.svg";